import { render, staticRenderFns } from "./ContentCategory.vue?vue&type=template&id=a1bce374&scoped=true"
import script from "./ContentCategory.vue?vue&type=script&lang=js"
export * from "./ContentCategory.vue?vue&type=script&lang=js"
import style0 from "./ContentCategory.vue?vue&type=style&index=0&id=a1bce374&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1bce374",
  null
  
)

export default component.exports